import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

type RouteSearch = { page: number }

export const Route = createFileRoute("/app/my/absences/")({
  component: lazyImportRouteComponent(
    () => import("./-components/MyAbsencesPage"),
    "MyAbsencesPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("MyAbsences"),
    }
  },
  validateSearch: (search: Record<string, unknown>): RouteSearch => {
    return { page: Number(search.page || 1) }
  },
})
